import ResumeFeedbackModal from "./ResumeFeedbackModal";

export default ResumeFeedbackModal;
